<template>
  <div dir="ltr" class="flex justify-center my-6">
    <button @click="changePage(1)" :disabled="getGlobalActivePage === 1"
      class="px-3 py-2 mx-1 text-sm rounded-md text-gray-700 hover:bg-gray-300 disabled:text-gray-700 disabled:bg-white border disabled:cursor-not-allowed">
      اول
    </button>
    <button @click="changePage(getGlobalActivePage - 1)" :disabled="getGlobalActivePage === 1"
      class="px-3 py-2 mx-1 text-sm rounded-md text-gray-700 hover:bg-gray-300 border disabled:text-gray-700 disabled:bg-white disabled:border disabled:cursor-not-allowed">
      قبلی
    </button>

    <template v-if="shouldShowEllipsisStart">
      <span class="px-3 py-2 mx-1 text-gray-700">...</span>
    </template>

    <div v-for="page in visiblePages" :key="page">
      <button type="button" @click="changePage(page)" class="default-page-button"
        :class="getGlobalActivePage === page ? 'bg-gray-600 !text-white hover:bg-gray-600' : 'bg-white !text-gray-700 hover:bg-gray-300'">
        {{ page }}
      </button>
    </div>

    <template v-if="shouldShowEllipsisEnd">
      <span class="px-3 py-2 mx-1 text-gray-700">...</span>
    </template>

    <button @click="changePage(getGlobalActivePage + 1)" :disabled="getGlobalActivePage === totalPages"
      class="px-3 py-2 mx-1 text-sm rounded-md text-gray-700 hover:bg-gray-300 border disabled:bg-white disabled:border disabled:text-gray-700 disabled:cursor-not-allowed">
      بعدی
    </button>
    <button @click="changePage(totalPages)" :disabled="getGlobalActivePage === totalPages"
      class="px-3 py-2 mx-1 text-sm rounded-md text-gray-700 hover:bg-gray-300 border disabled:bg-white disabled:border disabled:text-gray-700 disabled:cursor-not-allowed">
      آخر
    </button>
  </div>
</template>

<script>
import store from '@/store';

export default {
  name: 'PaginationPage',
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    maxVisiblePages: {
      type: Number,
      default: 5
    }
  },

  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    visiblePages() {
      const pages = [];
      const startPage = Math.max(1, this.getGlobalActivePage - Math.floor(this.maxVisiblePages / 2));
      const endPage = Math.min(this.totalPages, this.getGlobalActivePage + Math.floor(this.maxVisiblePages / 2));

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
    shouldShowEllipsisStart() {
      return this.visiblePages[0] > 1;
    },
    shouldShowEllipsisEnd() {
      return this.visiblePages[this.visiblePages.length - 1] < this.totalPages;
    },
    getGlobalActivePage() {
      return store.getters['panel/getGlobalActivePage'];
    }
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        store.dispatch("panel/setGlobalActivePage", page);
        this.$emit('page-change');
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  @apply flex justify-center mt-6 gap-x-4 mx-auto;
}

.default-page-button {
  @apply px-3 py-2 mx-1 rounded-md border shadow-sm
}

.next-button {
  @apply border text-xs px-2 py-2 rounded-xl disabled:bg-white disabled:cursor-not-allowed disabled:font-light;
}

.previous-button {
  @apply border text-xs px-2 py-2 rounded-xl disabled:bg-white disabled:cursor-not-allowed disabled:font-light;
}
</style>